export default {"src":"/_next/static/media/vote-solid.c342297f.svg","height":14,"width":18};